import { create } from 'zustand';

/** Overrides locaux des statuts commande — session démo commerçant (aucune persistance API). */
interface MerchantDemoOrderStore {
  statusById: Record<string, string>;
  setStatus: (id: string, status: string) => void;
  reset: () => void;
}

export const useMerchantDemoOrderStore = create<MerchantDemoOrderStore>((set) => ({
  statusById: {},
  setStatus: (id, status) =>
    set((s) => ({ statusById: { ...s.statusById, [id]: status } })),
  reset: () => set({ statusById: {} }),
}));

export type OrderStatusLike = { id: string; status: string };

export function applyMerchantDemoOrderPatch<T extends OrderStatusLike>(
  orders: T[],
  statusById: Record<string, string>,
): T[] {
  if (!orders.length || Object.keys(statusById).length === 0) return orders;
  return orders.map((o) => {
    const next = statusById[o.id];
    return next && next !== o.status ? { ...o, status: next } : o;
  });
}

/** Filtre onglets OrdersPage (clés multi-statuts séparées par virgule). */
export function orderMatchesStatusFilter(status: string, filter: string): boolean {
  if (filter === 'all') return true;
  const keys = filter.split(',').map((k) => k.trim()).filter(Boolean);
  if (keys.includes('pending')) {
    return status === 'pending' || status === 'pending_payment';
  }
  if (keys.includes('accepted')) {
    return status === 'accepted' || status === 'preparing';
  }
  return keys.includes(status);
}
